import { Decodable } from './_decodable';

class ReferralGamificationLevel extends Decodable {
    key?: string;
    label?: string;
    colorHex?: string;
    couponPercent?: number;
    nextKey?: string | null;
    nextLabel?: string | null;
    nextColorHex?: string | null;
    conversionsToNext?: number | null;
    progressPercent?: number;
}

class ReferralGamificationLevelOption extends Decodable {
    key?: string;
    label?: string;
    colorHex?: string;
    minConversions?: number;
    couponPercent?: number;
}

class ReferralGamificationStats extends Decodable {
    signupsCount?: number;
    conversionsCount?: number;
}

class ReferralGamificationCouponStats extends Decodable {
    activeCount?: number;
    usedCount?: number;
    applicablePercentTotal?: number;
    maxDiscountPercent?: number;
}

class ReferralCouponOwner extends Decodable {
    id?: number;
    name?: string;
}

class ReferralCouponWalletItem extends Decodable {
    id?: number;
    code?: string;
    discountPercent?: number;
    tier?: string | null;
    tierLabel?: string | null;
    tierColorHex?: string | null;
    source?: string;
    status?: string;
    owner?: ReferralCouponOwner;
    referredName?: string | null;
    issuedAt?: Date | null;
    expiresAt?: Date | null;
    usedAt?: Date | null;
    revokedAt?: Date | null;

    protected _map = {
        owner: (e) => ReferralCouponOwner.parse(e),
        issuedAt: (e) => this.parseDate(e),
        expiresAt: (e) => this.parseDate(e),
        usedAt: (e) => this.parseDate(e),
        revokedAt: (e) => this.parseDate(e),
    };
}

class ReferralDiscountPreviewItem extends Decodable {
    walletItemId?: number;
    code?: string;
    percent?: number;
}

class ReferralDiscountAvailableItem extends Decodable {
    walletItemId?: number;
    code?: string;
    percent?: number;
    source?: string;
    tierLabel?: string | null;
    expiresAt?: Date | null;
    selected?: boolean;
    selectable?: boolean;

    protected _map = {
        expiresAt: (e) => this.parseDate(e),
    };
}

class ReferralDiscountPreview extends Decodable {
    enabled?: boolean;
    blockedByManualCoupon?: boolean;
    availableItems?: ReferralDiscountAvailableItem[];
    items?: ReferralDiscountPreviewItem[];
    totalPercent?: number;
    capPercent?: number;
    capAmount?: number;
    capped?: boolean;
    subtotal?: number;
    manualDiscountAmount?: number;
    discountAmount?: number;
    combinedDiscountAmount?: number;
    finalAmount?: number;

    protected _map = {
        availableItems: (e) => ReferralDiscountAvailableItem.parse(e),
        items: (e) => ReferralDiscountPreviewItem.parse(e),
    };
}

class ReferralCouponApplication extends Decodable {
    id?: number;
    walletItemId?: number;
    code?: string;
    percent?: number;
    discountAmount?: number;
    status?: string;
}

class ReferralGamificationRecentReferral extends Decodable {
    name?: string;
    status?: string;
    registeredAt?: Date | null;
    convertedAt?: Date | null;

    protected _map = {
        registeredAt: (e) => this.parseDate(e),
        convertedAt: (e) => this.parseDate(e),
    };
}

class ReferralWallet extends Decodable {
    pendingCents?: number;
    coinsBalance?: number;
    collectableCoins?: number;
}

class ReferralSpinPrize extends Decodable {
    type?: string;
    percent?: number;
    label?: string;
    walletItemId?: number;
}

class ReferralSpin extends Decodable {
    spinNumber?: number;
    symbols?: string[];
    result?: string;
    prize?: ReferralSpinPrize | null;

    protected _map = {
        prize: (e) => e ? ReferralSpinPrize.parse(e) : null,
    };
}

class ReferralGamification extends Decodable {
    enabled?: boolean;
    referralLink?: string;
    level?: ReferralGamificationLevel;
    levels?: ReferralGamificationLevelOption[];
    stats?: ReferralGamificationStats;
    couponStats?: ReferralGamificationCouponStats;
    recentReferrals?: ReferralGamificationRecentReferral[];
    coinsEnabled?: boolean;
    signupRewardCents?: number;
    coinConversionCents?: number;
    slotEnabled?: boolean;
    wallet?: ReferralWallet;

    protected _map = {
        level: (e) => ReferralGamificationLevel.parse(e),
        levels: (e) => ReferralGamificationLevelOption.parse(e),
        stats: (e) => ReferralGamificationStats.parse(e),
        couponStats: (e) => ReferralGamificationCouponStats.parse(e),
        recentReferrals: (e) => ReferralGamificationRecentReferral.parse(e),
        wallet: (e) => ReferralWallet.parse(e),
    };
}

export {
    ReferralGamification,
    ReferralGamificationLevel,
    ReferralGamificationLevelOption,
    ReferralGamificationStats,
    ReferralGamificationCouponStats,
    ReferralGamificationRecentReferral,
    ReferralCouponOwner,
    ReferralCouponWalletItem,
    ReferralDiscountPreview,
    ReferralDiscountPreviewItem,
    ReferralDiscountAvailableItem,
    ReferralCouponApplication,
    ReferralWallet,
    ReferralSpin,
    ReferralSpinPrize,
};
